import Text from 'components/Text/Text';
import React, { useContext } from 'react';
import { Form } from 'antd';
import Button from 'components/Button/Button';
import breadcrumbs from 'images/breadcrumbs.svg';
import {
	CreateGameContext,
	ICreateGameContext,
} from 'modules/Entertainment/Games/CreateGame/createGameState/createGameContext';
import classNames from 'classnames';
import style from './BtnBlock.module.scss';

const BtnBlock: React.FC = () => {
	const {
		changeTypeOfModalWindow,
		name,
		IDSelectedDeveloper,
		IDSelectedCategory,
		versionCode,
		versionName,
		applicationId,
		description,
		IDsSelectedLanguages,
		fileId,
		fileData,
	} = useContext<ICreateGameContext>(CreateGameContext);
	const containerClasses = classNames(style.container, {
		[style.visible]:
			name ||
			IDSelectedDeveloper ||
			IDSelectedCategory ||
			IDsSelectedLanguages.length ||
			versionName ||
			versionCode ||
			applicationId ||
			description ||
			fileId ||
			fileData.fileId,
	});

	const handleCancel = () => {
		changeTypeOfModalWindow('toConfirmFieldsClearing');
	};

	return (
		<Form.Item>
			<div className={containerClasses} data-test="BtnBlock">
				<Button
					className={style.cancelBtn}
					theme="outlined"
					onClick={handleCancel}
					icon={
						<svg className={style.icon}>
							<use xlinkHref={`${breadcrumbs}#resetIcon`} />
						</svg>
					}
					data-test="cancelButton">
					<Text translationNameSpace="form" translationKey="cancelButton" asFragment={true} />
				</Button>
				<Button className={style.saveBtn} theme="primaryBlue" type="submit" data-test="saveButton">
					<Text translationNameSpace="form" translationKey="saveButton" asFragment={true} />
				</Button>
			</div>
		</Form.Item>
	);
};

export default BtnBlock;
